export default __webpack_public_path__ + "static/media/P_Pato.95b6945b.mp3";